// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../fetch.pb.js";
export var OverrideType;
(function (OverrideType) {
    OverrideType["OVERRIDE_TYPE_UNSPECIFIED"] = "OVERRIDE_TYPE_UNSPECIFIED";
    OverrideType["OVERRIDE_TYPE_VMO"] = "OVERRIDE_TYPE_VMO";
    OverrideType["OVERRIDE_TYPE_FWD"] = "OVERRIDE_TYPE_FWD";
})(OverrideType || (OverrideType = {}));
export var OverrideType_index;
(function (OverrideType_index) {
    OverrideType_index[OverrideType_index["OVERRIDE_TYPE_UNSPECIFIED"] = 0] = "OVERRIDE_TYPE_UNSPECIFIED";
    OverrideType_index[OverrideType_index["OVERRIDE_TYPE_VMO"] = 1] = "OVERRIDE_TYPE_VMO";
    OverrideType_index[OverrideType_index["OVERRIDE_TYPE_FWD"] = 2] = "OVERRIDE_TYPE_FWD";
})(OverrideType_index || (OverrideType_index = {}));
export const PhoneOverrideService = {
    /**
     * Create the override option.
     * Overrides are applied to a Call Route. A Call Route must exist first.
     */
    Create(fn, req) {
        return fn(`/phone/override/v2`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * List overrides by tenant.
     */
    List(fn, req) {
        return fn(`/phone/override/v2?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * Update the given override.
     */
    Update(fn, req) {
        return fn(`/phone/override/v2`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * Delete the override.
     */
    Delete(fn, req) {
        try {
            fm.validateUrlParam(req["phoneOverrideId"], "phoneOverrideId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/override/v2/${req["phoneOverrideId"]}?${fm.renderURLSearchParams(req, ["phoneOverrideId"])}`, { method: "DELETE" });
    },
};
